export type TeamSize = 'small' | 'medium' | 'big';

export type BusinessModel =
  | 'Marketplace'
  | 'Ecommerce'
  | 'Saas'
  | 'HaaS'
  | 'PaaS'
  | 'SharingEconomy'
  | 'Crowdsourcing'
  | 'Licensing'
  | 'OndemandServices'
  | 'D2C'
  | 'Crowdfunding'
  | 'ContentPlatform';

export type IndustrySector =
  | 'Edtech'
  | 'Healthtech'
  | 'Fintech'
  | 'Agritech'
  | 'Indtech'
  | 'RetailTech'
  | 'MobilityTransportation'
  | 'EnergyCleanTech'
  | 'Foodtech'
  | 'MediaEntertainment'
  | 'LogisticsSupplyChain'
  | 'HRTech'
  | 'TravelTech'
  | 'LegalTech'
  | 'Insurtech'
  | 'Other';

export type EducationLevel =
  | 'HighSchoolOrEquivalent'
  | 'technicalOrAssociateDegree'
  | 'BachelorsDegree'
  | 'MastersDegree'
  | 'DoctoratePhd'
  | 'OtherOrPreferNotToSay';

export enum UserRole {
  ADMIN = 'Admin',
  STARTUP = 'Startup',
  INCUBATOR = 'Incubator',
}

export enum LicenseStatus {
  NotAttributed = 'NotAttributed',
  First = 'First',
  Second = 'Second',
  Waiting = 'Waiting',
  Pending = 'Pending',
}
